module.exports = __webpack_public_path__ + "media/assets/icons/checkboxes/square-darkgray-ade3f292c1e5db9d577c9b76f4e4aa78.svg";